import { createAsyncThunk } from '@reduxjs/toolkit';
import { AuthApi } from '../../../api/base/Auth';

export const fetchAvailableForAppearancesIn = createAsyncThunk(
  'availableForAppearancesIn/fetchData',
  async (): Promise<Array<any>> => {
    const response = await AuthApi.getAvailableForAppearancesIn();
    return response.data.data;
  },
);
